import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOHead from '../components/Einwohnermeldeamt/SEOHead';
import GoldStars from '../components/GoldStars';
import { ratingConfig } from '../config/rating';

const ArrowIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
      clipRule="evenodd"
    />
  </svg>
);

const ctaBaseStyle: React.CSSProperties = {
  gap: '10px',
  color: '#fff',
  fontWeight: 600,
  fontSize: '19px',
  padding: '15px 32px',
  borderRadius: '6px',
  boxShadow: '0 4px 10px rgba(2,48,71,0.25)',
};

const Erfahrungen: React.FC = () => {
  const { ratingValue, ratingCount, bestRating } = ratingConfig;

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <SEOHead
        title="Erfahrungen & Bewertungen | AdressFinder.org"
        description="Lesen Sie echte Kundenbewertungen zur Online-Adressauskunft von AdressFinder.org – durchschnittlich 4.7 von 5 Sternen, basierend auf 259 Bewertungen. Schnell, sicher und digital."
      />

      <main className="flex-grow">
        {/* Hero */}
        <section
          className="text-center"
          style={{
            background: 'linear-gradient(180deg, #FDFDFE 0%, #F8F9FA 100%)',
            padding: '56px 24px 40px',
          }}
        >
          <div style={{ maxWidth: '760px', margin: '0 auto' }}>
            <div
              style={{ fontSize: '13px', color: '#6C757D', marginBottom: '18px' }}
            >
              <Link to="/" style={{ color: '#6C757D' }}>
                Startseite
              </Link>{' '}
              › Erfahrungen
            </div>

            <h1
              className="erfahrungen-hero-h1"
              style={{
                fontWeight: 800,
                color: '#023047',
                marginBottom: '14px',
                lineHeight: 1.25,
              }}
            >
              Erfahrungen &amp; Bewertungen zu AdressFinder.org
            </h1>

            <div
              className="flex items-center justify-center flex-wrap"
              style={{ gap: '14px', marginBottom: '14px' }}
            >
              <span
                style={{ fontSize: '26px', fontWeight: 800, color: '#023047' }}
              >
                Hervorragend
              </span>
              <GoldStars size={28} />
            </div>

            <p
              style={{
                fontSize: '17px',
                maxWidth: '620px',
                margin: '0 auto 28px',
                lineHeight: 1.55,
                color: '#212529',
              }}
            >
              Unsere Kunden bewerten die Online-Adressauskunft von
              AdressFinder.org mit{' '}
              <b style={{ fontWeight: 700 }}>
                {ratingValue} von {bestRating} – basierend auf {ratingCount}{' '}
                Bewertungen.
              </b>
            </p>

            <Link
              to="/personal-data"
              className="reviews-cta inline-flex items-center"
              style={{ ...ctaBaseStyle, background: '#023047' }}
            >
              Jetzt Adresse finden
              <ArrowIcon />
            </Link>
          </div>
        </section>

        {/* CTA band */}
        <section
          className="text-center"
          style={{ background: '#023047', padding: '56px 24px' }}
        >
          <h2
            style={{
              color: '#fff',
              fontSize: '30px',
              fontWeight: 800,
              marginBottom: '12px',
            }}
          >
            Überzeugen Sie sich selbst
          </h2>
          <p
            style={{
              color: 'rgba(255,255,255,0.8)',
              fontSize: '17px',
              marginBottom: '26px',
            }}
          >
            Starten Sie jetzt Ihre Melderegisterauskunft – schnell, sicher und
            digital.
          </p>
          <Link
            to="/personal-data"
            className="reviews-cta inline-flex items-center"
            style={{ ...ctaBaseStyle, background: '#32936F' }}
          >
            Jetzt Adresse finden
            <ArrowIcon />
          </Link>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Erfahrungen;
